import React, { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { Button } from '@mantine/core';

import { DeliveryManifest } from '../types';

type ManifestDownloadProps = {
  item: DeliveryManifest;
};

const ManifestDownload: React.FC<ManifestDownloadProps> = ({ item }) => {
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();
  if (!item.downloadPdfUrl || item.status === 'Confirmed') {
    return null;
  }

  const confirm = async () => {
    if (!item.confirmUrl) {
      return;
    }
    setLoading(true);

    try {
      await fetch(new URL(item.confirmUrl, import.meta.env.VITE_MY_FOODA_APP_URL).href, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          preview: item.confirmationPreview,
          token: item.confirmationToken,
        }),
      });

      await client.refetchQueries({
        include: 'active',
      });
    } catch (error) {
      console.error('Error confirming manifest:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={confirm} loading={loading}>
      Confirm
    </Button>
  );
};

export default ManifestDownload;
